import { useState } from 'react'
import { IntlShape, useIntl } from 'react-intl'

import { useTheme } from 'styled-components/native'

import {
  ELIGIBILITY_TYPES,
  EligibilityInfo,
  EligibilityType,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { generateEligibilityMetadata } from '../formMetadata/eligibilityMetadata'

type Params = {
  eligibilityInfo: EligibilityInfo
  eligibilityType?: EligibilityType
  showInternationalFormat?: boolean
  showEligibilityErrorBanner?: boolean
  hideDivider?: boolean
  countryIsoCode?: string
  blockInPersonCareForDependents?: boolean
}

/**
 * Handles generating the custom eligibility metadata if
 * the customer has one
 */
export const useEligibilityMetadata = ({
  eligibilityInfo,
  showInternationalFormat = false,
  showEligibilityErrorBanner = false,
  hideDivider = false,
  countryIsoCode,
  blockInPersonCareForDependents,
}: Params) => {
  const {
    breakpoints: { isMobileSized },
    colors,
    fontFamilyMetadata,
  } = useTheme()
  const intl: IntlShape = useIntl()
  const [eligibilityType, setEligibilityType] = useState(ELIGIBILITY_TYPES.EMPLOYEE as EligibilityType)

  const { customEligibilityMetadata } = eligibilityInfo
  const eligibilityMetadata = customEligibilityMetadata
    ? customEligibilityMetadata.generateMetadata({
        eligibilityInfo,
        eligibilityType,
        isMobileSized,
        intl,
        isInternational: showInternationalFormat,
        colors,
        fontFamilyMetadata,
      })
    : generateEligibilityMetadata({
        eligibilityInfo,
        showInternationalFormat,
        intl,
        hideDivider,
        showEligibilityErrorBanner,
        isMobileSized,
        colors,
        countryIsoCode,
        blockInPersonCareForDependents,
      })
  return {
    eligibilityMetadata,
    customFields: customEligibilityMetadata?.getCustomFields?.(eligibilityInfo),
    eligibilityType,
    setEligibilityType,
  }
}
